// Layout-matched loading placeholders. Use these instead of a centered Spinner
// so a page reserves its real shape while loading (no blank-then-pop shift).
// `Skeleton` is the atom (a pulsing slate block); the rest compose it.

export default function Skeleton({ className = "" }) {
  return (
    <div
      aria-hidden="true"
      className={`animate-pulse rounded-md bg-slate-200/70 ${className}`}
    />
  );
}

// A white card silhouette with optional placeholder lines.
export function SkeletonCard({ className = "", lines = 3 }) {
  return (
    <div
      aria-hidden="true"
      className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm ${className}`}
    >
      <Skeleton className="h-4 w-1/3 mb-4" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={`h-3 mb-2.5 ${i === lines - 1 ? "w-2/3" : "w-full"}`}
        />
      ))}
    </div>
  );
}

// A row of stat-card silhouettes (dashboard KPI header).
export function SkeletonStatRow({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          aria-hidden="true"
          className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
        >
          <Skeleton className="h-9 w-9 rounded-xl mb-3" />
          <Skeleton className="h-6 w-1/2 mb-2" />
          <Skeleton className="h-3 w-2/3" />
        </div>
      ))}
    </div>
  );
}
